import React from 'react';

export const SVGExpand: React.FC = () => {
    return (
        <div className="svg-icon expand-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M19.714 10.071H13.93V4.286c0-.71-.576-1.286-1.286-1.286h-1.286c-.71 0-1.286.576-1.286 1.286v5.785H4.286c-.71 0-1.286.576-1.286 1.286v1.286c0 .71.576 1.286 1.286 1.286h5.785v5.785c0 .71.576 1.286 1.286 1.286h1.286c.71 0 1.286-.576 1.286-1.286V13.93h5.785c.71 0 1.286-.576 1.286-1.286v-1.286c0-.71-.576-1.286-1.286-1.286z" fill="currentColor"/></svg>
        </div>
    );
}
